import { render, staticRenderFns } from "./HotelStats.vue?vue&type=template&id=9bef730c&scoped=true"
import script from "./HotelStats.vue?vue&type=script&lang=js"
export * from "./HotelStats.vue?vue&type=script&lang=js"
import style0 from "./HotelStats.vue?vue&type=style&index=0&id=9bef730c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bef730c",
  null
  
)

export default component.exports